var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KHeader',{attrs:{"scrollFlag":true}}),_c('MediaForm'),_c('KFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }